import { useSelector } from "react-redux";

export default function useScope() {
  return useSelector(state => state.scope);
}
